import { documentReady, getNodeIndex, qs } from '@utils/toolbox';
import { RecentSearches } from '@module/RecentSearches/RecentSearches';

const init = function () {
	window.recentSearches = new RecentSearches();

	setupMenuItemClick();
};

const menuItemClicked = function (index, item) {
	const hitlists = document.getElementsByClassName('hitlist-wrapper');
	qs('.active').classList.remove('active');
	item.classList.add('active');

	for (let i = 0; i < hitlists.length; i++) {
		hitlists[i].classList.add('hidden');
	}

	hitlists[index].classList.remove('hidden');
};

function setupMenuItemClick () {
	const sortList = document.getElementById('hitlist-wrapper');

	sortList.addEventListener('click', function (e) {
		const target = e.target;
		const menuItem = target.closest('.abTabNav__btn');

		menuItemClicked(getNodeIndex(menuItem), menuItem);
	});
}

documentReady(init);
